<template>
  <div class="html-doc-pro">
    <div class="html-doc-pro--header">
      <div class="htmldph--left">
        <div class="htmldph--left--title">
          <span v-if="editorEnabled || advancedEditorEnabled">{{
            $t("html_editor")
          }}</span>
          <span v-if="!(editorEnabled || advancedEditorEnabled)">{{
            $t("html_viewer")
          }}</span>
          <span class="document-name">: {{ documentName }} </span>
        </div>
      </div>
      <div class="htmldph--right">
        <button
          class="dt-button v5 s8"
          v-if="!advancedEditorEnabled"
          @click="onAdvancedEdit"
        >
          {{ $t("advanced_editor") }}
        </button>
        <button
          class="dt-button v3 c5"
          :title="$t('copy_document')"
          @click="onCopy"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="-0.5"
              y="0.5"
              width="13.7881"
              height="13.7984"
              rx="2.5"
              transform="matrix(-1 0 0 1 19 2)"
              stroke="#0087FF"
            />
            <rect
              x="-0.5"
              y="0.5"
              width="13.7881"
              height="13.7984"
              rx="2.5"
              transform="matrix(-1 0 0 1 15.7881 5.2016)"
              stroke="#0087FF"
            />
          </svg>
        </button>
        <!-- <button
          class="dt-button v3 c5"
          :title="$t('download_as_pdf')"
          @click="onDownloadPDF"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.548 8.1C5.79067 8.1 6.017 8.17 6.227 8.31C6.44167 8.45 6.61433 8.639 6.745 8.877C6.87567 9.115 6.941 9.381 6.941 9.675C6.941 9.96433 6.87567 10.228 6.745 10.466C6.61433 10.704 6.44167 10.8953 6.227 11.04C6.017 11.18 5.79067 11.25 5.548 11.25H4.26L4.33 11.124V12.573C4.33 12.6943 4.29267 12.797 4.218 12.881C4.14333 12.9603 4.04533 13 3.924 13C3.80733 13 3.71167 12.9603 3.637 12.881C3.56233 12.797 3.525 12.6943 3.525 12.573V8.527C3.525 8.40567 3.56467 8.30533 3.644 8.226C3.728 8.142 3.83067 8.1 3.952 8.1H5.548ZM5.548 10.452C5.63667 10.452 5.723 10.4147 5.807 10.34C5.891 10.2653 5.961 10.1697 6.017 10.053C6.073 9.93167 6.101 9.80567 6.101 9.675C6.101 9.53967 6.073 9.41367 6.017 9.297C5.961 9.18033 5.891 9.087 5.807 9.017C5.723 8.94233 5.63667 8.905 5.548 8.905H4.246L4.33 8.779V10.564L4.253 10.452H5.548ZM9.84277 8.1C10.1788 8.1 10.4774 8.163 10.7388 8.289C11.0001 8.415 11.2194 8.59233 11.3968 8.821C11.5788 9.045 11.7141 9.30633 11.8028 9.605C11.8961 9.899 11.9428 10.214 11.9428 10.55C11.9428 11.0027 11.8611 11.4157 11.6978 11.789C11.5344 12.1577 11.2964 12.4517 10.9838 12.671C10.6758 12.8903 10.2954 13 9.84277 13H8.16977C8.04844 13 7.94577 12.9603 7.86177 12.881C7.78244 12.797 7.74277 12.6943 7.74277 12.573V8.527C7.74277 8.40567 7.78244 8.30533 7.86177 8.226C7.94577 8.142 8.04844 8.1 8.16977 8.1H9.84277ZM9.77277 12.195C10.0668 12.195 10.3071 12.1203 10.4938 11.971C10.6804 11.817 10.8158 11.6163 10.8998 11.369C10.9884 11.117 11.0328 10.844 11.0328 10.55C11.0328 10.3307 11.0071 10.123 10.9558 9.927C10.9091 9.72633 10.8344 9.55133 10.7318 9.402C10.6291 9.248 10.4984 9.12667 10.3398 9.038C10.1811 8.94933 9.99211 8.905 9.77277 8.905H8.54777L8.61777 8.842V12.272L8.57577 12.195H9.77277ZM13.1877 13C13.057 13 12.9497 12.9603 12.8657 12.881C12.7863 12.797 12.7467 12.6943 12.7467 12.573V8.527C12.7467 8.40567 12.7863 8.30533 12.8657 8.226C12.9497 8.142 13.0523 8.1 13.1737 8.1H15.4487C15.57 8.1 15.6703 8.13967 15.7497 8.219C15.8337 8.29367 15.8757 8.39167 15.8757 8.513C15.8757 8.61567 15.8337 8.70667 15.7497 8.786C15.6703 8.86533 15.57 8.905 15.4487 8.905H13.5587L13.6217 8.821V10.228L13.5727 10.137H15.1337C15.255 10.137 15.3553 10.1767 15.4347 10.256C15.5187 10.3307 15.5607 10.4287 15.5607 10.55C15.5607 10.6527 15.5187 10.7437 15.4347 10.823C15.3553 10.9023 15.255 10.942 15.1337 10.942H13.5587L13.6217 10.879V12.573C13.6217 12.6943 13.5773 12.797 13.4887 12.881C13.4047 12.9603 13.3043 13 13.1877 13Z"
              fill="#0087FF"
            />
            <path
              d="M15.2419 2.22234L17.7578 4.71015C18.2327 5.17977 18.5 5.8199 18.5 6.48781V16C18.5 17.3807 17.3807 18.5 16 18.5H4C2.61929 18.5 1.5 17.3807 1.5 16V4C1.5 2.61929 2.61929 1.5 4 1.5H13.4841C14.1423 1.5 14.7739 1.75956 15.2419 2.22234Z"
              stroke="#0087FF"
            />
          </svg>
        </button> -->
        <button
          class="dt-button v3 c5"
          :title="
            editorEnabled || advancedEditorEnabled
              ? $t('close_editor')
              : $t('edit_document')
          "
          @click="onToggleClick"
        >
          <svg
            v-if="!(editorEnabled || advancedEditorEnabled)"
            width="20"
            height="20"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.5 3H4.88889C4.38792 3 3.90748 3.19901 3.55324 3.55324C3.19901 3.90748 3 4.38792 3 4.88889V18.1111C3 18.6121 3.19901 19.0925 3.55324 19.4468C3.90748 19.801 4.38792 20 4.88889 20H18.1111C18.6121 20 19.0925 19.801 19.4468 19.4468C19.801 19.0925 20 18.6121 20 18.1111V11.5"
              stroke="#0087FF"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M17.1791 3.48399C17.489 3.1741 17.9093 3 18.3476 3C18.7858 3 19.2061 3.1741 19.516 3.48399C19.8259 3.79388 20 4.21418 20 4.65243C20 5.09068 19.8259 5.51099 19.516 5.82088L12.1159 13.221L9 14L9.77896 10.8841L17.1791 3.48399Z"
              stroke="#0087FF"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <svg
            v-if="editorEnabled || advancedEditorEnabled"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <line
              x1="3.71753"
              y1="16.2912"
              x2="15.7383"
              y2="4.27043"
              stroke="#0087FF"
              stroke-linecap="round"
            />
            <line
              x1="0.5"
              y1="-0.5"
              x2="17.5"
              y2="-0.5"
              transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 15.7698 16.9984)"
              stroke="#0087FF"
              stroke-linecap="round"
            />
          </svg>
        </button>
        <!-- <button class="dt-button v5 s8" v-if="!editorEnabled" @click="onEdit">
          Edit Document
        </button> -->
        <!-- <button class="dt-button v5 s8" @click="onDownload">Download</button>
        <button class="dt-button v51 s8" @click="onDownloadPDF">
          Download as PDF
        </button> -->
        <!-- <button class="dt-button v5 s8" @click="onToggleClick">
          {{
            advancedEditorEnabled
              ? "Back to Editor"
              : editorEnabled
              ? "Back to Viewer"
              : "Edit Document"
          }}
        </button> -->
      </div>
    </div>
    <div
      class="html-doc-pro--body"
      :class="{
        'editor-mode': editorEnabled,
        'advanced-editor-mode': advancedEditorEnabled,
        'viewer-mode': !editorEnabled && !advancedEditorEnabled,
        focused: isEditorFocused,
      }"
      @focusin="handleFocusIn"
      @focusout="isEditorFocused = false"
    >
      <div class="html-body" ref="htmlBody" v-if="!advancedEditorEnabled">
        <div ref="shadowHost"></div>
      </div>
      <transition name="fade-slide-down">
        <div class="popup" v-if="showPopup">
          <div class="popup-icon">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.876 11.906C9.55867 11.906 9.386 11.7287 9.358 11.374L8.952 6.222C8.93333 5.93267 9.008 5.69 9.176 5.494C9.35333 5.298 9.582 5.2 9.862 5.2C10.142 5.2 10.3707 5.298 10.548 5.494C10.7253 5.69 10.8 5.93267 10.772 6.222L10.38 11.374C10.352 11.7287 10.184 11.906 9.876 11.906ZM9.778 15C9.50733 15 9.29733 14.93 9.148 14.79C9.008 14.6407 8.938 14.4307 8.938 14.16V13.922C8.938 13.6513 9.008 13.446 9.148 13.306C9.29733 13.1567 9.50733 13.082 9.778 13.082H9.96C10.2307 13.082 10.436 13.1567 10.576 13.306C10.7253 13.446 10.8 13.6513 10.8 13.922V14.16C10.8 14.4307 10.7253 14.6407 10.576 14.79C10.436 14.93 10.2307 15 9.96 15H9.778Z"
                fill="white"
              />
              <path
                d="M2.70577 5.78867L10 1.57735L17.2942 5.78867V14.2113L10 18.4227L2.70577 14.2113V5.78867Z"
                stroke="white"
              />
            </svg>
          </div>

          <p>
            {{ $t("please_note_change_not_saved") }}
          </p>
        </div>
      </transition>
      <HtmlEditor
        v-if="advancedEditorEnabled"
        :value="htmlData"
        @input="onHtmlDataInput"
      ></HtmlEditor>
    </div>
    <!-- <pre style="height: 150px"> {{ htmlData }} </pre> -->
  </div>
</template>

<script>
import DomPurify from "dompurify";

import {
  addScriptCode,
  addTitle,
  openHTMLWindow,
  printHTML,
} from "../../utility/html.util.js";
import HtmlEditor from "@plugins/html-editor/html-editor";
import { sanitizeFilename, wait } from "../../utility/index.js";

export default {
  components: {
    HtmlEditor,
  },
  props: {
    documentName: {
      type: String,
      required: true,
    },
    htmlData: {
      type: String,
      required: true,
    },
    openEditorAsDefault: {
      type: Boolean,
      default: true,
    },
    canEdit: {
      type: Boolean,
      default: true,
    },
  },
  data: function () {
    return {
      editorEnabled: true,
      advancedEditorEnabled: false,

      isEditorFocused: false,
      showPopup: false,
      firstFocus: true,

      textChanged: false,
      initialContent: "",
    };
  },
  watch: {
    htmlData(newVal) {
      this.updateShadowRoot(newVal);
      this.textChanged = false;
    },
    advancedEditorEnabled(newVal) {
      // if (!newVal) {
      //   this.updateShadowRoot(this.htmlData);
      // }
    },
    editorEnabled(newVal) {
      // if (newVal) {
      // }
      // this.updateShadowRoot(this.htmlData);
    },
  },
  computed: {},
  methods: {
    getShadowRootDivHtml() {
      let shadowHost = this.$refs.shadowHost;
      let shadowRoot = shadowHost ? shadowHost.shadowRoot : null;
      let shadowRootDiv = shadowRoot
        ? shadowRoot.querySelector("div.shadow-root-div")
        : null;
      return shadowRootDiv ? shadowRootDiv.innerHTML : "";
    },
    updateShadowRoot(htmlData) {
      console.log(
        `Updating shadow root. EditorEn: ${this.editorEnabled}. AdvEditorEn: ${
          this.advancedEditorEnabled
        }.  htmlData.Length: ${htmlData?.length || 0}`
      );

      if (this.advancedEditorEnabled) {
        return;
      }
      if (!this.$refs?.shadowHost) {
        return;
      }

      let shadowRoot = this.$refs.shadowHost.shadowRoot;
      // console.log({'html-doc-pro.vue:355 shadowRoot' : shadowRoot});
      if (!shadowRoot) {
        console.log("Creating shadow root");
        shadowRoot = this.$refs.shadowHost.attachShadow({ mode: "open" });
        const editableDiv = document.createElement("div");
        editableDiv.className = "shadow-root-div";
        if (this.editorEnabled) {
          console.log("Setting contentEditable to true");
          editableDiv.contentEditable = "true";

          editableDiv.addEventListener("input", () => {
            this.textChanged = true;
          });
        }
        shadowRoot.appendChild(editableDiv);
      } else {
        console.log("Shadow root already exists");
      }

      if (shadowRoot && !this.editorEnabled) {
        console.log("Not editorEnabled: Setting contentEditable to false");
        // Get shadow root div
        let shadowRootDiv = shadowRoot.querySelector("div.shadow-root-div");

        // Make shadowRootDiv not contentEditable
        if (shadowRootDiv) {
          shadowRootDiv.contentEditable = "false";
        }

        if (shadowRootDiv) {
          shadowRootDiv.innerHTML = htmlData;
        }
      } else if (shadowRoot && this.editorEnabled) {
        console.log("editorEnabled: Setting contentEditable to true");
        // Get shadow root div
        let shadowRootDiv = shadowRoot.querySelector("div.shadow-root-div");

        // Make shadowRootDiv contentEditable
        if (shadowRootDiv) {
          shadowRootDiv.contentEditable = "true";
        }

        if (shadowRootDiv) {
          shadowRootDiv.innerHTML = htmlData;
        }
      }

      console.log("Setting HTML");
      // Set HTML
      shadowRoot.querySelector("div.shadow-root-div").innerHTML = htmlData;
    },
    editedHTML() {
      if (this.editorEnabled) {
        return this.getShadowRootDivHtml();
      } else {
        return this.htmlData;
      }
    },
    async showPopupFirstTime() {
      if (this.firstFocus) {
        this.showPopup = true;
        this.firstFocus = false;
        setTimeout(() => {
          this.showPopup = false;
        }, 3000); // hide popup after 3 seconds
      }
    },

    extractTable() {
      const parser = new DOMParser();
      const doc = parser.parseFromString(this.editedHTML(), "text/html");

      console.log({ "html-doc-pro.vue:415 doc": doc, html: this.editedHTML() })
      // Now Find the table
      const table = doc.querySelector("table");

      return table;
    },
    tableToDelimiterSV(table, delimiter = ",") {
      console.log({ "html-doc-pro.vue:415 table": table });

      const headers = Array.from(table.querySelectorAll("th")).map((th) =>
        th.textContent.trim()
      );
      const rows = Array.from(table.querySelectorAll("tr"));
      rows.shift();
      const csv = rows
        .map((row) => {
          const cells = Array.from(row.querySelectorAll("td"));
          return cells.map((cell) => {
            // If cell has comma, wrap it in quotes
            if (cell.textContent.includes(",")) {
              return `"${cell.textContent.trim()}"`;
            }
            return cell.textContent.trim();
          }).join(delimiter);
        })
        .join("\n");
      return `${headers.join(delimiter)}\n${csv}`;
    },
    async exportAsCSV() {
      const csvString = this.tableToDelimiterSV(this.extractTable());

      const blob = new Blob([csvString], { type: "text/csv;charset=utf-8" });
      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = `${sanitizeFilename(this.documentName)}.csv`;
      link.click();
    },
    async copyAsCSV() {
      const csvString = this.tableToDelimiterSV(this.extractTable());

      // Copy to clipboard as a CSV File, so that it can be pasted into Excel
      navigator.clipboard.writeText(csvString);
    },
    async copyAsXLSX() {
      const csvString = this.tableToDelimiterSV(this.extractTable(),  '\t');

      // Copy to clipboard as a CSV File, so that it can be pasted into Excel
      navigator.clipboard.writeText(csvString);
    },

    async onDownload() {
      // openHTMLWindow(addTitle(this.editedHTML, this.documentName));
      // console.log(this.editedHTML());
      // console.log(this.editedHTML)

      // await wait(500);
      const data = addTitle(this.editedHTML(), this.documentName);
      const blob = new Blob([data], { type: "text/html;charset=utf-8" });
      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = `${sanitizeFilename(this.documentName)}.html`;
      link.click();
    },
    async onDownloadPDF() {
      openHTMLWindow(addTitle(printHTML(this.editedHTML()), this.documentName));
    },
    async openInNewTab() {
      openHTMLWindow(addTitle(this.editedHTML(), this.documentName));
    },
    async onAdvancedEdit() {
      this.updateHtmlData();
      this.editorEnabled = false;
      this.advancedEditorEnabled = true;

      this.showPopupFirstTime();
    },
    async onEdit() {
      this.editorEnabled = true;
      this.advancedEditorEnabled = false;
    },
    onToggleClick() {
      // console.log({
      //   "html-doc-pro.vue:415 this.editorEnabled": this.editorEnabled,
      // });
      if (this.advancedEditorEnabled) {
        this.editorEnabled = false;
        this.advancedEditorEnabled = false;

        this.$nextTick(() => {
          this.updateShadowRoot(this.htmlData);
        });
      } else if (this.editorEnabled) {
        if (this.textChanged) {
          this.updateHtmlData();
        } else {
          this.$nextTick(() => {
            this.updateShadowRoot(this.htmlData);
          });
        }

        this.editorEnabled = false;
        this.advancedEditorEnabled = false;
      } else {
        this.$nextTick(() => {
          this.updateShadowRoot(this.htmlData);
        });
        this.editorEnabled = true;
        this.advancedEditorEnabled = false;
      }
    },

    async onHtmlDataInput(value) {
      // console.log({ "html-doc-pro.vue:282 value Length": value?.length || 0 });
      console.log("Updating HTML Data Prop HtmlEditor");
      this.$emit("input", value);
    },
    async updateHtmlData(event) {
      if (!this.advancedEditorEnabled) {
        console.log("Updating HTML Data Prop Manually");
        this.$emit("input", this.editedHTML());
      }
    },
    onCopy() {
      navigator.clipboard.writeText(this.editedHTML());
    },
    handleFocusIn() {
      this.isEditorFocused = true;
      this.showPopupFirstTime();
    },
    //MARK: Methods
  },
};
</script>

<style lang="scss" scoped>
/* Add any styles for your HTML viewer here */
.html-doc-pro {
  flex: 1;
  height: 380px;
  display: flex;
  flex-direction: column;
  overflow: auto;
  margin: 0px 16px;

  position: relative;

  .html-doc-pro--header {
    height: 30px;
    background-color: #f5f5f5;
    border-bottom: 1px solid #e5e5e5;
    margin-bottom: 4px;

    display: flex;
    align-items: center;

    justify-content: space-between;
    border-radius: 4px;

    .htmldph--right {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding-right: 10px;
      button {
        // margin-left: 10px;
      }
    }
    .htmldph--left {
      display: flex;
      align-items: center;
      padding-left: 10px;
      .htmldph--left--title {
        font-size: 14px;
        font-weight: 600;
        color: var(--text-secondary);
      }
    }
  }
  .html-doc-pro--body {
    flex: 1;
    overflow: auto;
    padding: 10px;

    [contenteditable] {
      outline: none;
    }
    &.viewer-mode {
      background-color: whitesmoke;
      // background-color: hsl(53, 24%, 96%);
      border: 1px solid transparent;
    }
    &.editor-mode,
    &.advanced-editor-mode {
      border: 1px solid hsl(0, 0%, 66%);
    }
    &.focused {
      border: 1px solid hsl(0, 0%, 36%);
    }

    .popup {
      position: absolute;
      bottom: 10px;
      left: 10px;
      padding: 10px;
      background: var(--bc-accent5);
      color: #ffffff;
      border: 1px solid #ccc;
      border-radius: 5px;
      .popup-icon {
        float: left;
        margin-right: 10px;
      }
      p {
        margin-bottom: 4px;
      }
    }
  }
}
</style>